import React from 'react';

import { useRouter } from 'next/router';

import { urlFiltersToCioFacets } from '~/grid/utils/cioUtils';

import useCioBrowseAndGqlProducts from '../../hooks/useCioBrowseAndGqlProducts';
import {
  clearAllCioFacetsFromUrlParams,
  getTransformedFacetOptionDisplayName,
  updateFiltersInUrlParams,
} from '../../utils/filters';

const DesktopGridSelectedFilters = () => {
  const { selectedUrlFilters, allCioFacetNames, allCioFacets } =
    useCioBrowseAndGqlProducts();
  const router = useRouter();

  // Map the selected URL facets to the corresponding CIO facets
  // so that we can display the correct facet names and options
  // and also upate the URL params when the user clicks on a facet
  // to remove it from the selected filters
  const selectedCioFacets = Object.entries(selectedUrlFilters).flatMap(
    ([key, value]) => {
      const cioFacetName = urlFiltersToCioFacets[key] || key;

      // we need to check against allCioFacets due to size filters being
      // in cio prefilter expressions instead of the filters param so there
      // are potential cases where the size filters will not be returned in
      // the cioFacets to render in the Filters UI
      const cioFacet = allCioFacets?.find(
        (facet) => facet?.name === cioFacetName
      );

      if (cioFacet) {
        return value?.map((option) => {
          const cioOption = cioFacet?.options?.find(
            (facetOption) => facetOption?.value === option
          );
          return {
            facetName: cioFacetName,
            urlName: key,
            facetOption: option,
            facetOptionDisplayName: getTransformedFacetOptionDisplayName({
              selectedFacetName: cioFacetName,
              selectedFacetDisplayName: cioFacet?.display_name,
              selectedFacetOptionDisplayName: cioOption?.display_name,
            }),
          };
        });
      }
      return [];
    }
  );

  const handleClearAllFilters = () => {
    clearAllCioFacetsFromUrlParams({
      router,
      allCioFacetNames,
    });
  };

  const handleOnClick = ({ facetName, facetOption }) => {
    updateFiltersInUrlParams({
      facetName,
      facetOption,
      router,
    });
  };

  return (
    <div className="flex flex-col gap-2 pb-3 border-b-2">
      <div className="flex justify-between pb-3">
        <p>Filtered by:</p>
        <button
          type="button"
          onClick={handleClearAllFilters}
          className="underline"
        >
          Clear all
        </button>
      </div>
      <ul className="flex flex-wrap gap-[4px]">
        {selectedCioFacets?.map(
          ({ facetName, facetOption, facetOptionDisplayName }) => {
            return (
              <li
                key={`${facetName}-${facetOption}`}
                className="border-2 px-[4px] text-[14px] bg-gray-200 flex gap-2 items-center"
              >
                <span>{facetOptionDisplayName}</span>
                <button
                  type="button"
                  className="border-0 px-[8px] bg-gray-300"
                  onClick={() =>
                    handleOnClick({
                      facetName,
                      facetOption,
                    })
                  }
                >
                  x
                </button>
              </li>
            );
          }
        )}
      </ul>
    </div>
  );
};

export default DesktopGridSelectedFilters;
